import * as React from "react";

import { cn } from "@/libs/utils";
import { VariantProps, cva } from "class-variance-authority";

const messageVariants = cva(
  "text-coolgray-60 text-sm font-500 peer-has-[:disabled]:text-coolgray-30 has-[:disabled]:text-coolgray-30",
  {
    variants: {
      error: {
        true: "text-red-60",
      },
    },
  }
);

export type MessageVariants = VariantProps<typeof messageVariants>;

const Message = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement> &
    VariantProps<typeof messageVariants>
>(({ className, error, ...props }, ref) => {
  return (
    <p
      className={cn(messageVariants({ error }), className)}
      ref={ref}
      {...props}
    />
  );
});
Message.displayName = "Message";

export { Message };
